import { Button, Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  ORDER_STATUS_SUCCESS,
  PHONE_CONTACT,
  ROUTER_PATH,
} from "../../common/constant";
import CopyComponent from "../../components/copyComponent";
import { LoadingCheckMark, SadFace } from "../../components/images";
import { ISectionCSS } from "../../models/interface/ISectionCSS";
import { actionClearShoppingCart } from "../../redux/reducers/slice/cart";
import { selectContacts } from "../../redux/reducers/slice/common";
import { localizeRouteKey } from "../../shared/helpers";
import * as GTM from "../../components/tracking/GTM";

import "./orderAlertModalStyle.scss";

const AlertModal = (props: any) => {
  const {
    history,
    orderResponse,
    isVisible,
    handleClose,
    typeAlert,
    errorMessage,
  } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const contacts = useSelector(selectContacts);

  const styleText: ISectionCSS = {
    "--txtAlign": orderResponse.info_transfer ? "left" : "center",
  };

  const handleClick = (contact: any) => {
    if (contact.type === "live") {
      GTM.trackingEventDynamic("clickFBCustomerChat");
    } else if (contact.type === "phone") {
      GTM.trackingEventDynamic("clickContactHotline");
    }
    if (contact.type === "live") {
      window.open(contact.url);
    } else {
      window.location.href = contact.url;
    }
  };

  const renderContent = (status: any) => {
    if (status === ORDER_STATUS_SUCCESS) {
      return (
        <div style={styleText}>
          <div className="alert-modal-icon">
            <img src={LoadingCheckMark} alt="" />
          </div>
          <span className="main-title alert-modal-title mgb-20">
            Đặt hàng thành công!
          </span>
          <span className="main-content alert-modal-content alert-modal-content-order-id-wrap ">
            Mã đơn hàng của Quý khách là
            <span className="main-title alert-modal-content alert-modal-order-id">
              {orderResponse.order_id || "ABC54321"}
            </span>
          </span>
          {orderResponse.info_transfer ? (
            <div className="alert-modal-content internet-banking-info main-content">
              <span className="internet-banking-info-title">
                Quý khách vui lòng chuyển khoản cho đơn hàng vào tài khoản giao
                dịch của KYMDAN theo nội dung như sau:
              </span>
              <div className="internet-banking-info-wrap">
                <div className="internet-banking-info-item">
                  <span className="internet-banking-info-item-label">
                    Tên tài khoản:
                  </span>
                  <span className="internet-banking-info-item-content">
                    {orderResponse.info_transfer.payment_name || ""}
                  </span>
                </div>
                <div className="internet-banking-info-item">
                  <span className="internet-banking-info-item-label">
                    Số tài khoản:
                  </span>
                  <span className="internet-banking-info-item-content">
                    {orderResponse.info_transfer.payment_number_card || ""}
                  </span>
                  <CopyComponent
                    classNameBtn="internet-banking-info-item-btn"
                    classNameMessage="internet-banking-info-item-message"
                    content="Sao chép"
                    text={orderResponse.info_transfer.payment_number_card || ""}
                  />
                </div>
                <div className="internet-banking-info-item">
                  <span className="internet-banking-info-item-label">
                    Tại ngân hàng:
                  </span>
                  <span className="internet-banking-info-item-content">
                    {orderResponse.info_transfer.payment_bank || ""}
                  </span>
                </div>
                {orderResponse.total_price ? (
                  <div className="internet-banking-info-item">
                    <span className="internet-banking-info-item-label">
                      Số tiền:
                    </span>
                    <span className="internet-banking-info-item-content">
                      {orderResponse.total_price} VND
                    </span>
                  </div>
                ) : null}
                <div className="internet-banking-info-item">
                  <span className="internet-banking-info-item-label">
                    Nội dung:
                  </span>
                  <span className="internet-banking-info-item-content">
                    {orderResponse.info_transfer.payment_note || ""}
                  </span>
                  <CopyComponent
                    classNameBtn="internet-banking-info-item-btn"
                    classNameMessage="internet-banking-info-item-message"
                    content="Sao chép"
                    text={orderResponse.info_transfer.payment_note || ""}
                  />
                </div>
              </div>
            </div>
          ) : null}
          <span className="main-content alert-modal-content mgb-15">
            Chúng tôi sẽ liên hệ với Quý khách để xác nhận đơn hàng trong vòng
            24h. Cảm ơn Quý khách đã lựa chọn sử dụng sản phẩm của Kymdan!
          </span>

          <span className="main-content alert-modal-content">
            Quý khách cần tư vấn thêm thông tin, vui lòng liên hệ{" "}
            <a style={{ whiteSpace: "nowrap" }} href={`tel:${PHONE_CONTACT}`}>
              {PHONE_CONTACT}
            </a>
          </span>
        </div>
      );
    }

    return (
      <div>
        <div className="alert-modal-icon">
          <img src={SadFace} alt="" />
        </div>
        <span className="main-title alert-modal-title mgb-20 alert-modal-order-id">
          Đã có lỗi xảy ra!
        </span>
        <span className="main-content alert-modal-content">
          {errorMessage ||
            "Đã xảy ra lỗi trong quá trình đặt đơn hàng. Quý khách vui lòng thử lại hoặc liên hệ với chúng tôi để biết thêm thông tin chi tiết:"}
        </span>

        <div className="contact-us-wrapper alert-modal-contact-wapper">
          <div className="contact-us-item-wrapper">
            {contacts &&
              contacts.length &&
              contacts.map((item: any) => (
                <a
                  className={`contact-us-item-wrap ${
                    item.type === "email" ? "display-none" : ""
                  }`}
                  onClick={() => handleClick(item)}>
                  <img src={item.images.path} alt="" />
                  <span className="item-title main-content">{item.title}</span>
                </a>
              ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <Modal
      className="kd-order-alert-modal"
      width={orderResponse.info_transfer ? 1050 : 700}
      visible={isVisible}
      // visible={true}
      //   title={t("order_success_title")}
      //   closeIcon={false}
      //   closable={false}
      onCancel={handleClose}
      footer={
        typeAlert === ORDER_STATUS_SUCCESS
          ? [
              <Button
                style={{ lineHeight: 1 }}
                className="main-content"
                key="back"
                onClick={() => {
                  dispatch(actionClearShoppingCart());
                  history.push(localizeRouteKey(ROUTER_PATH.HOME));
                }}>
                {t("back_to_home")}
              </Button>,
              <Button
                style={{ lineHeight: 1 }}
                key="submit"
                className="kd-btn-primary-2 main-content"
                onClick={() => {
                  dispatch(actionClearShoppingCart());
                  history.push(
                    localizeRouteKey(ROUTER_PATH.ORDERS) +
                      `/${orderResponse.id || ""}`
                  );
                }}>
                {t("go_to_order")}
              </Button>,
            ]
          : null
      }>
      {renderContent(typeAlert)}
    </Modal>
  );
};

export default AlertModal;
